/**
 * DownloadsUserEvents
 * Registry of events for the Downloads pages
 */
export enum DownloadsUserEvents {
    LoginCtaConfirmed = "Downloads - Login CTA Confirmed",
    LoginCtaClosed = "Downloads - Login CTA Closed",
    // Events for Custom Exports
    CustomExcelExportError = "Downloads - Custom Excel Export Error",
    CustomExcelExportSuccess = "Downloads - Custom Excel Export Success",
    CustomExcelExportAttempted = "Downloads - Custom Excel Export Attempted",
    CustomCsvExportError = "Downloads - Custom CSV Export Error",
    CustomCsvExportSuccess = "Downloads - Custom CSV Export Success",
    CustomCsvExportAttempted = "Downloads - Custom CSV Export Attempted",
    OpenDataDownloadContactModal = "Downloads - Open Data Download Contact Modal",
    CustomExcelExportConfirmed = "Downloads - Custom Excel Export Confirmed",
    CustomCsvExportConfirmed = "Downloads - Custom CSV Export Confirmed",
}
